import { RefreshIcon } from "@xola/icons";
import { Modal } from "@xola/ui-kit";
import { clamp, isNil, noop } from "lodash";
import React, { ReactNode } from "react";
import { SecondaryButton } from "./SecondaryButton";

interface OverlayLoaderProps {
    isOpen: boolean;
    color: string;
    description?: ReactNode;
    progress?: number | null;
    showCancelButton?: boolean;
    onCancel?: () => void;
    onClose?: () => void;
}

export const OverlayLoader = ({
    isOpen,
    color = "primary",
    description,
    progress,
    showCancelButton = false,
    onCancel,
    onClose,
}: OverlayLoaderProps) => {
    return (
        <Modal
            size="large"
            className="!p-0"
            isOpen={isOpen}
            shouldCloseOnOutsideClick={false}
            onClose={onClose ? onClose : noop}
        >
            <ModalContent
                color={color}
                progress={progress}
                showCancelButton={showCancelButton}
                description={description}
                onCancel={onCancel}
            />
        </Modal>
    );
};

type ModalContentProps = Omit<OverlayLoaderProps, "isOpen">;

const ModalContent = ({ color, description, progress, showCancelButton, onCancel }: ModalContentProps) => {
    const progressValue = isNil(progress) ? null : clamp(progress, 0, 100);

    return (
        <Modal.Body className="!mt-0">
            <div className="flex items-center justify-start space-x-4 bg-primary-lighter p-4">
                <RefreshIcon size="large" className="animate-spin" />
                <div className="w-full space-y-2">
                    <div className="flex items-center justify-between">
                        <div className="space-y-1 text-black">
                            <h4 className="font-bold">Processing</h4>
                            <p data-testid="progress-bar-success-msg">{description}</p>
                        </div>
                        {showCancelButton && (
                            <SecondaryButton size="small" onClick={onCancel}>
                                Cancel
                            </SecondaryButton>
                        )}
                    </div>
                    {progressValue ? (
                        <div className="h-2 w-full rounded-full bg-white">
                            <div className={`bg-${color} h-2 rounded-full`} style={{ width: `${progressValue}%` }} />
                        </div>
                    ) : null}
                </div>
            </div>
        </Modal.Body>
    );
};
